/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import produce from 'immer';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const createConfigsSlice = (set) => ({
  storeId: null,
  loadingConfigs: true,
  devolutionPageConfigs: null,
  storeConfigs: null,
  itemCategories: null,
  itemReasons: null,
  integrationStatus: null,
  setStoreId: (storeId) => {
    set(
      produce((draft) => {
        draft.storeId = storeId;
      }),
    );
  },
  setLoadingConfigs: (value) => {
    set(
      produce((draft) => {
        draft.loadingConfigs = value;
      }),
    );
  },
  setPageConfigs: (configs) => {
    set(
      produce((draft) => {
        draft.devolutionPageConfigs = configs.devolutionPageConfigs;
        draft.storeConfigs = configs.storeConfigs;
        draft.itemCategories = configs.itemCategories;
        draft.itemReasons = configs.itemReasons;
        draft.integrationStatus = configs.integrationStatus;
      }),
    );
  },
});

const useConfigsStore = create(
  devtools(
    (...a) => ({
      ...createConfigsSlice(...a),
    }),
    { name: 'PublicPageConfigsStore' },
  ),
);

export default useConfigsStore;
